/* Header extras (sections/header.liquid). Opening/closing the search strip and the phone drawer is theme.js
   ([data-toggle-target]); this file adds:
   - desktop dropdowns (<details data-header-dropdown>): one open at a time, close on outside click / Escape /
     focus leaving, aria-expanded kept in sync (also for the drawer accordions);
   - the cart bubble (#CartCount): hidden at 0; follows any script that rewrites its text, a `cart:updated`
     event ({ detail: { item_count } }) and pages restored from the back/forward cache;
   - sticky header: shadow once the page scrolls, and --header-h set to the real header height;
   - drawer: Tab stays inside while open; closes itself when the window grows to desktop width. */
(function () {
  "use strict";

  var header = document.querySelector("[data-header]");
  if (!header) return;

  /* ---------- dropdowns + accordions ---------- */
  var dropdowns = Array.prototype.slice.call(header.querySelectorAll("details[data-header-dropdown]"));

  Array.prototype.forEach.call(header.querySelectorAll("details"), function (details) {
    var summary = details.querySelector("summary");
    if (!summary) return;
    details.addEventListener("toggle", function () {
      summary.setAttribute("aria-expanded", String(details.open));
      if (details.open && details.hasAttribute("data-header-dropdown")) {
        dropdowns.forEach(function (other) {
          if (other !== details) other.open = false;
        });
      }
    });
  });

  dropdowns.forEach(function (details) {
    details.addEventListener("focusout", function (e) {
      if (details.open && e.relatedTarget && !details.contains(e.relatedTarget)) details.open = false;
    });
  });

  document.addEventListener("click", function (e) {
    dropdowns.forEach(function (details) {
      if (details.open && !details.contains(e.target)) details.open = false;
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    dropdowns.forEach(function (details) {
      if (!details.open) return;
      details.open = false;
      var summary = details.querySelector("summary");
      if (summary) summary.focus();
    });
  });

  /* ---------- cart bubble ---------- */
  var count = document.getElementById("CartCount");
  if (count) {
    var syncCount = function () {
      var n = parseInt(count.textContent, 10) || 0;
      count.hidden = n <= 0;
    };
    var setCount = function (n) {
      n = parseInt(n, 10) || 0;
      count.textContent = n > 99 ? "99+" : String(n);
    };
    if ("MutationObserver" in window) {
      new MutationObserver(syncCount).observe(count, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener("cart:updated", function (e) {
      if (e.detail && typeof e.detail.item_count === "number") setCount(e.detail.item_count);
    });
    window.addEventListener("pageshow", function (e) {
      if (!e.persisted || !window.fetch) return;
      var url = (header.getAttribute("data-cart-url") || "/cart") + ".js";
      fetch(url, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); })
        .catch(function () {});
    });
    syncCount();
  }

  /* ---------- sticky header ---------- */
  if (header.classList.contains("header--sticky")) {
    var ticking = false;
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 4);
      ticking = false;
    };
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });
    onScroll();

    var setHeight = function () {
      document.documentElement.style.setProperty("--header-h", header.offsetHeight + "px");
    };
    if ("ResizeObserver" in window) new ResizeObserver(setHeight).observe(header);
    else setHeight();
  }

  /* ---------- drawer ---------- */
  var drawer = document.getElementById("MenuDrawer");
  if (drawer) {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';

    drawer.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || drawer.hidden) return;
      var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
        return el.getClientRects().length > 0;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    if (window.matchMedia) {
      var desktop = window.matchMedia("(min-width: 990px)");
      var closeOnDesktop = function (e) {
        if (!e.matches || drawer.hidden) return;
        var closer = drawer.querySelector(".drawer__close");
        if (closer) closer.click();
      };
      if (desktop.addEventListener) desktop.addEventListener("change", closeOnDesktop);
      else if (desktop.addListener) desktop.addListener(closeOnDesktop);
    }
  }
})();
